exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7c03ea73] .el-table__fixed-right{height:100%!important}", ""]);

// exports
